import { render, staticRenderFns } from "./profile.html?vue&type=template&id=56dc4878&scoped=true&"
import script from "./profile.js?vue&type=script&lang=js&"
export * from "./profile.js?vue&type=script&lang=js&"
import style0 from "./profile.css?vue&type=style&index=0&id=56dc4878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc4878",
  null
  
)

export default component.exports